import { Routes } from '@angular/router';
import { PatientEditComponent } from '../../core/components/patient/patient-edit/patient-edit.component';
import { PatientNavigationEnum } from './navigation.enum';
import { BasketComponent } from './pages/basket/basket.component';
import { CalendarComponent } from './pages/calendar/calendar.component';
import { CompletionRegistrationComponent } from './pages/completion-registration/completion-registration.component';
import { CompletionRestoreComponent } from './pages/completion-restore/completion-restore.component';
import { HomeComponent } from './pages/home/home.component';
import { orderRoutes } from './pages/order/order.routes';
import { PatientAiChatComponent } from './pages/patient-ai-chat/patient-ai-chat.component';
import { PatientSignInComponent } from './pages/patient-sign-in/patient-sign-in.component';
import { PatientSignUpComponent } from './pages/patient-sign-up/patient-sign-up.component';
import { patientTelediagnosisRoutes } from './pages/patient-telediagnosis/patient-telediagnosis.routes';
import { patientMainRoutes } from './pages/profile/patient-main/patient-main.routes';
import { ProfileComponent } from './pages/profile/profile.component';
import { RestoreComponent } from './pages/restore/restore.component';
import { PatientComponent } from './patient.component';
import { canActivateAuthBasket } from '@core/guards/auth-basket.guard';
import { canActivateAuthPatient } from '@core/guards/auth-patient.guard';

export const patientRoutes: Routes = [
  { path: 'sign-in', component: PatientSignInComponent },
  { path: 'sign-up', component: PatientSignUpComponent },
  {
    path: 'completion-registration-patient',
    component: CompletionRegistrationComponent,
  },
  { path: 'restore', component: RestoreComponent },
  { path: 'completion-restore', component: CompletionRestoreComponent },

  {
    path: PatientNavigationEnum.basket,
    component: BasketComponent,
    canActivate: [canActivateAuthBasket],
  },
  {
    path: '',
    component: PatientComponent,
    canActivate: [canActivateAuthPatient],
    children: [
      { path: '', redirectTo: '', pathMatch: 'full' },
      { path: '', component: HomeComponent },
      {
        path: '',
        loadChildren: () => import('./pages/order/order.routes').then(() => orderRoutes),
      },
      {
        path: PatientNavigationEnum.calendar,
        component: CalendarComponent,
      },
      {
        path: PatientNavigationEnum.profile,
        component: ProfileComponent,
        children: [
          {
            path: '',
            redirectTo: '',
            pathMatch: 'full',
          },
          {
            path: '',
            loadChildren: () =>
              import('./pages/profile/patient-main/patient-main.routes').then(() => patientMainRoutes),
          },
          {
            path: PatientNavigationEnum.profile_edit,
            component: PatientEditComponent,
          },
        ],
      },
      {
        path: '',
        loadChildren: () =>
          import('./pages/patient-telediagnosis/patient-telediagnosis.routes').then(() => patientTelediagnosisRoutes),
      },
      {
        path: PatientNavigationEnum.physical_assistant,
        component: PatientAiChatComponent,
      },
      {
        path: PatientNavigationEnum.access,
        loadComponent: () => import('./pages/access/access.component').then((m) => m.AccessComponent),
      },
    ],
  },
];
